/**
 * This is meant to be used for select controls and other things that require id/value pairs
 */

export class ListItem {
  id: string;
  value: string;

  constructor(id: string, value: string) {
    this.id = id;
    this.value = value;
  }
}
